const clippingRequests = {
  firestorePath: 'clippingRequests',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'clippingRequests',
  statePropName: 'data',
  namespaced: true, // automatically added
  sync: {
    // debounceTimerMs: 50
    // defaults to 1000
  },
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%', // default
      updated_at: '%convertTimestamp%', // default
      // define each field like so ↑ in an object here
    },
  },
  // you can also add state/getters/mutations/actions
  state: {
  },
  getters: {
    obj: state => state.data,
    byId: (state) => (id) => state.data[id],
    array: state => Object.values(state.data),
  },
  mutations: {},
  actions: {
  
          
  
  }
}
export default clippingRequests